import { defineComponent as p, createBlock as y, openBlock as l, resolveDynamicComponent as k, mergeProps as h, unref as e, withCtx as m, createElementBlock as u, createCommentVNode as b, renderSlot as _, normalizeClass as d, createVNode as f } from "vue";
import { D as g } from "./DIcon-DTQWfP1x.js";
import { E as $, a as R, b as z } from "./const-CBRa5y2-.js";
import { _ as A } from "./_plugin-vue_export-helper-CHgC5LLL.js";
import './assets/DButton-ckumnJ3b.css';var s = /* @__PURE__ */ ((r) => (r.PRIMARY = "primary", r.BLACK = "black", r.GREY = "grey", r.WHITE = "white", r.DANGER = "danger", r))(s || {}), n = /* @__PURE__ */ ((r) => (r.LARGE = "large", r.SMALL = "small", r))(n || {});
const E = /* @__PURE__ */ p({
  compatConfig: {
    MODE: 3
  },
  __name: "DButton",
  props: {
    color: { type: String, default: s.PRIMARY },
    size: { type: String, default: n.LARGE },
    disabled: Boolean,
    dark: Boolean,
    short: Boolean,
    peakyCorners: Boolean,
    /** если указан, ренередится как ссылка, иначе - кнопка */
    to: { type: String, default: void 0 },
    /** аналогично `<a target="" />` */
    target: { type: String, default: void 0 },
    loading: Boolean,
    /** блоковый/строчный элемент */
    block: Boolean
  },
  emits: ["click"],
  setup(r, { emit: i }) {
    const o = r, c = i;
    return (t, a) => (l(), y(k(o.to ? "a" : "button"), h({
      type: o.to ? void 0 : "button",
      href: o.to ? o.to : void 0,
      target: o.to ? o.target : void 0
    }, {
      class: ["d-button", {
        [t.$style["d-button"]]: !0,
        [t.$style["d-button_rounded"]]: !o.peakyCorners,
        [t.$style["d-button_color-primary"]]: o.color === e(s).PRIMARY,
        [t.$style["d-button_color-black"]]: o.color === e(s).BLACK,
        [t.$style["d-button_color-grey"]]: o.color === e(s).GREY,
        [t.$style["d-button_color-white"]]: o.color === e(s).WHITE,
        [t.$style["d-button_color-danger"]]: o.color === e(s).DANGER,
        [t.$style["d-button_color-primary_dark"]]: o.dark && o.color === e(s).PRIMARY,
        [t.$style["d-button_color-black_dark"]]: o.dark && o.color === e(s).BLACK,
        [t.$style["d-button_color-grey_dark"]]: o.dark && o.color === e(s).GREY,
        [t.$style["d-button_color-white_dark"]]: o.dark && o.color === e(s).WHITE,
        [t.$style["d-button_color-danger_dark"]]: o.dark && o.color === e(s).DANGER,
        [t.$style["d-button_size-large"]]: o.size === e(n).LARGE,
        [t.$style["d-button_size-small"]]: o.size === e(n).SMALL,
        [t.$style["d-button_size-large_short"]]: o.short && o.size === e(n).LARGE,
        [t.$style["d-button_size-small_short"]]: o.short && o.size === e(n).SMALL,
        [t.$style["d-button_block"]]: o.block
      }],
      disabled: o.disabled || o.loading,
      onClick: a[0] || (a[0] = (D) => c("click"))
    }), {
      default: m(() => [
        t.$slots.prepend ? (l(), u("div", {
          key: 0,
          class: d(t.$style["d-button__prepend"])
        }, [
          _(t.$slots, "prepend")
        ], 2)) : b("", !0),
        _(t.$slots, "default"),
        t.$slots.append || o.loading ? (l(), u("div", {
          key: 1,
          class: d(t.$style["d-button__append"])
        }, [
          _(t.$slots, "append"),
          f(e(g), {
            name: e(z).LOADERS_DEFAULT,
            color: e(R).PRIMARY,
            size: e($).S_24,
            class: d(t.$style["d-button__icon_spin"])
          }, null, 8, ["name", "color", "size", "class"])
        ], 2)) : b("", !0)
      ], void 0, !0),
      _: 3
    }, 16, ["class", "disabled"]));
  }
}), L = "_spin_8fhso_1", B = {
  "d-button": "_d-button_8fhso_7",
  "d-button_block": "_d-button_block_8fhso_27",
  "d-button_rounded": "_d-button_rounded_8fhso_31",
  "d-button__prepend": "_d-button__prepend_8fhso_34",
  "d-button__append": "_d-button__append_8fhso_39",
  "d-button_size-large": "_d-button_size-large_8fhso_44",
  "d-button_size-large_short": "_d-button_size-large_short_8fhso_55",
  "d-button_size-small": "_d-button_size-small_8fhso_65",
  "d-button_size-small_short": "_d-button_size-small_short_8fhso_70",
  "d-button_color-primary": "_d-button_color-primary_8fhso_73",
  "d-button_color-primary_dark": "_d-button_color-primary_dark_8fhso_83",
  "d-button_color-black": "_d-button_color-black_8fhso_93",
  "d-button_color-black_dark": "_d-button_color-black_dark_8fhso_103",
  "d-button_color-grey": "_d-button_color-grey_8fhso_113",
  "d-button_color-grey_dark": "_d-button_color-grey_dark_8fhso_123",
  "d-button_color-white": "_d-button_color-white_8fhso_133",
  "d-button_color-white_dark": "_d-button_color-white_dark_8fhso_143",
  "d-button_color-danger": "_d-button_color-danger_8fhso_153",
  "d-button_color-danger_dark": "_d-button_color-danger_dark_8fhso_163",
  "d-button__icon_spin": "_d-button__icon_spin_8fhso_186",
  spin: L
}, v = {
  $style: B
}, C = /* @__PURE__ */ A(E, [["__cssModules", v]]);
export {
  C as D,
  n as E,
  s as a
};
